import { UserContactDto } from '@markant-platform/registration/model';

export const MOCK_USER_CONTACT: UserContactDto = {
  userId: '66ed906d47cb08b37e764b8f',
  salutation: 'm',
  firstname: 'Jorge',
  lastname: 'Abel',
  email: 'jorge.abel@example.markant.com',
  platformTermsOfUseTimestamp: '1726845104',
  platformPrivacyNoticeTimestamp: '1726845104',
};
